import { render, staticRenderFns } from "./ButtonsInput.vue?vue&type=template&id=179d1a26&"
import script from "./ButtonsInput.vue?vue&type=script&lang=js&"
export * from "./ButtonsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports